import { useState } from 'react'
import { removeAttachment, postFormWithProgress } from 'services/receipt'

export const useUploadImages = (breakId, step) => {
  const [uploadProgress, setUploadProgress] = useState(null)
  const [uploadedImages, setUploadedImages] = useState([])
  const [uploadErrors, setUploadErrors] = useState(null)
  const [receiptSubmissionId, setReceiptSubmissionId] = useState(null)

  const handleUploadProgress = progress => {
    try {
      setUploadProgress(prevProgress => ({
        ...prevProgress,
        progress,
      }))
    } catch {
      setUploadProgress({ progress })
    }
  }

  const parseUploadError = rawError => {
    const defaultMessage = `Error uploading receipt. Please try again. ${rawError}`

    try {
      const error = JSON.parse(rawError)

      const message = error?.message

      if (!message) return defaultMessage

      return message
    } catch {
      return defaultMessage
    }
  }

  const handleSingleFileUpload = async file => {
    try {
      setUploadErrors(null)
      setUploadProgress({ filename: file.name, progress: 0 })

      const payload = new FormData()
      payload.append('file', file)
      payload.append('breakId', breakId)
      payload.append('stepId', step.id)
      payload.append('receiptId', step.receiptVerificationCampaign.id)

      if (receiptSubmissionId !== null || window.receiptSubmissionID) {
        const submissionID = receiptSubmissionId || window.receiptSubmissionID
        payload.append('receiptSubmissionId', submissionID)
        console.log('appended receiptSubmissionId: ' + submissionID)
      }
      const result = await postFormWithProgress(
        '/receiptVerification/upload',
        payload,
        handleUploadProgress,
      )

      const parsedResult = JSON.parse(result)

      setReceiptSubmissionId(parsedResult.receiptSubmissionId)
      setUploadedImages(prevImages => [
        ...prevImages,
        { file, info: parsedResult },
      ])

      setUploadProgress(null)
      console.log(parsedResult.receiptSubmissionId)

      console.log('done uploading')
      return parsedResult.receiptSubmissionId
    } catch (error) {
      setUploadProgress(null)
      setUploadErrors(parseUploadError(error))
    }
  }

  const handleImageUpload = async files => {
    if (typeof window !== `undefined`) {
      window.receiptSubmissionID = null
      for await (const file of files) {
        window.receiptSubmissionID = await handleSingleFileUpload(file)
      }
    }
  }

  const handleRemoveImage = async id => {
    try {
      const response = await removeAttachment(
        breakId,
        step.id,
        step.receiptVerificationCampaign.id,
        receiptSubmissionId,
        id,
      )

      if (response.status === 200) {
        setUploadedImages(prevImages =>
          prevImages.filter(image => image.info.id !== id),
        )
      } else {
        const result = await response.json()
        console.warn('Upload result', result)
      }
    } catch (error) {
      setUploadErrors(error)
    }
  }

  return {
    uploadProgress,
    uploadedImages,
    uploadErrors,
    handleImageUpload,
    handleRemoveImage,
    setUploadErrors,
    receiptSubmissionId,
  }
}
